import { useSpotDetailAttachedStateMachine } from './detail/useSpotDetailAttachedStateMachine'
import { useSpotsFetchStateMachine } from './useSpotsFetchStateMachine'

/**
 * スポット一覧ページの統合フック。
 * - useSpotsFetchStateMachine: スポット取得・タブ・フィルタ・ARフォトオーバーレイ
 * - useSpotDetailAttachedStateMachine: ARフォトロック・音声ガイドダイアログ（詳細ページと共通）
 */
export const useSpotListStateMachine = ({
  isAuthenticated,
  defaultSheetId,
}: {
  isAuthenticated: boolean
  defaultSheetId: number | null
}) => {
  const list = useSpotsFetchStateMachine({ isAuthenticated, defaultSheetId })
  const attached = useSpotDetailAttachedStateMachine()

  return {
    list,
    attached,
  }
}
